// extracted by mini-css-extract-plugin
module.exports = {"el":"PortfolioProject-module--el--31g9P","title":"PortfolioProject-module--title--uyKoG","image":"PortfolioProject-module--image--3zu0w"};